import CartModal from './CartModal/CartModal'
import MenuModal from './MenuModal/MenuModal'
import FiltersModal from './FiltersModal/FiltersModal'

const Modals = () => {
    return (
        <>
            <CartModal/>
            <MenuModal/>
            <FiltersModal/>
        </>
    )
}

export default Modals
